import { extendServiceContainer } from '@iotize/tap';
import { DeviceService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    device: DeviceService;
  }
}

export const _TAP_SERVICE_EXTENSION_DEVICE_ = extendServiceContainer(
  'device',
  DeviceService,
);
